function exportExercise(exercise) {
  return {
    name: exercise.name,
    category: exercise.lib_category || null,
    equipment: exercise.equipment || null,
    target_sets: exercise.target_sets,
    target_reps_min: exercise.target_reps_min,
    target_reps_max: exercise.target_reps_max,
    rest_seconds: exercise.rest_seconds,
    notes: exercise.notes || null,
    is_timed: Boolean(exercise.is_timed),
    alternatives: (exercise.alternatives || []).map(exportExercise),
  };
}

export function createProgramExport(programs, exportedAt = new Date().toISOString()) {
  return {
    format: 'muscuapp-programs',
    version: 1,
    exportedAt,
    programs: programs.map((program) => ({
      name: program.name,
      icon: program.icon,
      color: program.color,
      description: program.description || '',
      exercises: (program.exercises || []).map(exportExercise),
    })),
  };
}

export function downloadProgramExport(programs) {
  const exportedAt = new Date().toISOString();
  const data = createProgramExport(programs, exportedAt);
  const date = exportedAt.slice(0, 10);
  const programName = programs.length === 1
    ? programs[0].name
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '') || 'programme'
    : 'programmes';
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `muscuapp-${programName}-${date}.json`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}
